import {
  IDetailCopyItem,
  TransactionDetailV2ACustomerItem,
  Typenames,
} from '@varo/graphql-schema-types';

export function hasCopy(
  item,
): item is IDetailCopyItem | TransactionDetailV2ACustomerItem {
  return (
    (item as IDetailCopyItem).copy !== undefined &&
    (item as IDetailCopyItem).copy !== ''
  );
}

export function isTransactionDetailV2ACustomerItem(
  item,
): item is TransactionDetailV2ACustomerItem {
  return (
    (item as TransactionDetailV2ACustomerItem).__typename ===
    Typenames.TransactionDetailV2ACustomerItem
  );
}
